import type { RouteLocationNormalized } from 'vue-router';

import { routenames } from '../routenames';
import { useAccountStore } from '@/stores/accountStore';

export async function eulaGuard(to: RouteLocationNormalized) {
  const { currentUser } = useAccountStore();

  const passed = currentUser?.eulaAccepted || to.meta.noAuthRequired;

  if (!passed) {
    return {
      name: routenames.eula,
    };
  }
}
